import React from "react";
import { Form, Table } from "antd";
import { setWidgetInSheetParams, updateWidgetSettings } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { connect } from "react-redux";
import { getList } from "services/api/Api";
import { injectIntl } from "react-intl";
import { ListScripts } from "../../ListWidget/Lists/listScripts";
import { isActivePublicUser } from "../../../../util/Scripts";
import {
   Message,
   Switch,
   Button,
   Spin,
   Input,
   Radio,
   RadioGroup,
   Popconfirm,
} from "../../../BP2Components";

const EditableContext = React.createContext();
const EditableRow = ({ form, index, ...props }) => (
   <EditableContext.Provider value={form}>
      <tr {...props} />
   </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
   state = {
      editing: false,
   };

   toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
         if (editing) {
            this.input?.focus();
         }
      });
   };

   save = (e) => {
      const { record, handleSave } = this.props;
      this.form.validateFields((error, values) => {
         if (error && error[e.currentTarget.id]) {
            return;
         }
         this.toggleEdit();
         if (values.itemsPerPage) {
            values.itemsPerPage = +values.itemsPerPage;
         }
         handleSave({ ...record, ...values });
      });
   };

   renderCell = (form) => {
      this.form = form;
      const { children, dataIndex, record, title } = this.props;
      const { editing } = this.state;
      return editing ? (
         <Form.Item style={{ margin: 0 }}>
            {this.form.getFieldDecorator(dataIndex, {
               rules: [
                  {
                     message: `${title} is required.`,
                  },
               ],
               initialValue: record[dataIndex],
            })(
               <Input
                  style={{ width: "220px", fontSize: "12px" }}
                  ref={(node) => (this.input = node)}
                  onPressEnter={this.save}
                  onBlur={this.save}
               />,
            )}
         </Form.Item>
      ) : (
         <div
            className="editable-cell-value-wrap"
            style={{ paddingRight: 24 }}
            onClick={this.toggleEdit}
         >
            {children}
         </div>
      );
   };

   render() {
      const { editable, dataIndex, title, record, index, handleSave, children, ...restProps } =
         this.props;
      return (
         <td {...restProps}>
            {editable ? (
               <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
            ) : (
               children
            )}
         </td>
      );
   }
}

class ListSettings extends React.Component {
   constructor(props) {
      super(props);
      this.columns = [
         {
            title: <IntlMessages id="settings.serieName" />,
            dataIndex: "name",
            editable: true,
         },
         {
            title: <IntlMessages id="settings.query" />,
            dataIndex: "query",
            editable: true,
            width: 180,
            maxWidth: 400,
         },
         {
            title: <IntlMessages id="settings.listId" />,
            dataIndex: "listId",
            editable: true,
            width: 120,
            render: (text, record) => (
               <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <span>{text}</span>
                  <Button
                     size="small"
                     onClick={(e) => {
                        e.stopPropagation();
                        this.handleEditListBuilder(record.listId);
                     }}
                  >
                     <IntlMessages id="global.edit" />
                  </Button>
               </div>
            ),
         },
         {
            title: <IntlMessages id="settings.itemsPerPage" />,
            dataIndex: "itemsPerPage",
            editable: true,
         },
         {
            title: <IntlMessages id="boardManager.operation" />,
            dataIndex: "operation",
            render: (text, record) =>
               this.state.listWidgetSeries.length >= 1 ? (
                  <>
                     <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => this.handleDelete(record.listWidgetSerieKey)}
                     >
                        <a className="gx-mr-5">
                           <IntlMessages id="global.delete" />
                        </a>
                     </Popconfirm>
                  </>
               ) : null,
         },
      ];

      let rows = [];
      let series = [];

      if (props.listWidgetSeries !== undefined && props.listWidgetSeries.length > 0) {
         series = props.listWidgetSeries;
         rows = [];
      }
      series.forEach((serie) => {
         rows.push({
            listWidgetSerieKey: props.listWidgetSeries.indexOf(serie),
            id: serie.id,
            name: serie.name,
            query: serie.query,
            listId: serie.listId,
            itemsPerPage: serie.itemsPerPage,
            columnProperties: serie.columnProperties,
            listWidgetSerieSettings: serie.listWidgetSerieSettings,
         });
      });
      this.state = {
         id: this.props.id,
         name: this.props.name,
         xsWidth: this.props.xs,
         smWidth: this.props.sm,
         mdWidth: this.props.md,
         lgWidth: this.props.lg,
         xlWidth: this.props.xl,
         priority: this.props.priority,
         showListName: this.props.showListName,
         listWidgetSeries: this.props.listWidgetSeries,
         count: rows.length,
         columnProperties: this.props.columnProperties,
         selected: this.props.selectedSerie,
         currentRowClicked: null,
         stateChange: 0,
         mapLocalizationFieldName: this.props.localizationFieldName,
         mapClickFilterColName: this.props.mapClickFilterColName,
         mapDefaultZoomLevel: this.props.defaultZoomLevel,
         mapViewListSerie: this.props.viewListSerie,
         mapListSerie: this.props.mapListSerie,
         mapIndependentSerie: this.props.mapIndependentSerie,
         mapPointColName: this.props.mapPointColName,
         mapDistanceColName: this.props.mapDistanceColName,
         mapAddressColName: this.props.mapAddressColName,
         showMap: this.props.showMap,
         filterByLocation: this.props.filterByLocation,
         distanceToFilter: this.props.distanceToFilter,
         maxDistanceToFilter: props.maxDistanceToFilter,
         setDistanceColumnHidden: this.props.setDistanceColumnHidden,
         expandedRow: null,
         showPlacefinder: this?.props?.showPlacefinder,
         showUrlButton: props.showUrlButton,
         urlColumn: props.urlColumn,
         ulrButtonTitle: props.ulrButtonTitle,
      };
   }

   getSerieById = (serieId) => {
      const { listWidgetSeries } = this.state;
      let searchedSerie = null;
      listWidgetSeries.forEach((serie) => {
         if (serieId == serie.listWidgetSerieKey) {
            searchedSerie = serie;
         }
      });
      return searchedSerie;
   };

   handleSubmit = (e) => {
      e.preventDefault();
      const { expandedRow } = this.state;
      this.setState({
         stateChange: (this.state.stateChange += Math.random()),
      });
      var i = 0;

      if (expandedRow && expandedRow.columnProperties !== undefined && expandedRow !== null) {
         expandedRow.columnProperties.forEach((col) => {
            col.orderKey = i;
            i++;
            if (col.addition !== true) {
               col.addition = false;
            }
         });
      }
      this.props.updateWidgetSettings(this.state);
      this.props.setWidgetInSheetParams(this.state);
      Message.success(this.props.intl.formatMessage({ id: "global.saved" }));
   };
   handleSwitch = (checked, serie, name) => {
      this.setState((prevState) => {
         let updatedSerie = { ...prevState };
         updatedSerie.listWidgetSeries[
            this.props.value.listWidgetSeries.findIndex((item) => item.id == serie.id)
         ][name] = checked;
         this.props.updateWidgetSettings(this.state);
         return { updatedSerie };
      });
   };

   handleAdd = () => {
      this.setState(
         (prevState) => {
            const newData = {
               listWidgetSerieKey: prevState.count + 1,
               id: Math.floor(Math.random() * 100000) + 1,
               query: "Click to add query",
               name: "Click to add name",
               listId: 12,
               itemsPerPage: 10,
               listWidgetSerieSettings: ListScripts.getBasicSerieSettings(),
               columnProperties: [],
            };

            return {
               listWidgetSeries: [...prevState.listWidgetSeries, newData],
               count: prevState.count + 1,
            };
         },
         () => {
            this.props.updateWidgetSettings(this.state);
         },
      );
   };
   handleSave = (row) => {
      const newData = [...this.state.listWidgetSeries];
      const index = newData.findIndex((item) => row.listWidgetSerieKey === item.listWidgetSerieKey);
      if (index > -1) {
         const item = newData[index];
         newData.splice(index, 1, {
            ...item,
            ...row,
         });
         this.setState({ listWidgetSeries: newData }, () => {
            this.props.updateWidgetSettings(this.state);
         });
      }
   };
   handleDelete = (listWidgetSerieKey) => {
      const series = [...this.state.listWidgetSeries];
      this.setState(
         {
            listWidgetSeries: series.filter(
               (item) => item.listWidgetSerieKey !== listWidgetSerieKey,
            ),
         },
         () => {
            this.props.updateWidgetSettings(this.state);
         },
      );
   };

   handleEditListBuilder = (listId) => {
      if (listId) {
         window.open(`/listbuilder?listId=${listId}`, "_blank");
      } else {
         Message.warning(this.props.intl.formatMessage({ id: "global.pleaseEnterListId" }, { defaultMessage: "Proszę wpisać List ID" }));
      }
   };

   onExpandRow = (rowClicked, currentRowClicked) => {
      this.setState({
         selected: currentRowClicked.listWidgetSerieKey,
         currentRowClicked: currentRowClicked,
      });

      if (isNaN(currentRowClicked.listId) == true) {
         // this.getQueryData(currentRowClicked);
      } else {
         this.getBPdata(currentRowClicked);
      }

      this.setState({ expandedRow: currentRowClicked });
   };

   renderCloudResponse(res, length) {
      if (res[0]) {
         const cols = Object.keys(res[0]);

         const columnsCopy = [];
         cols.forEach((column) => {
            columnsCopy.push({
               title: column,
               dataIndex: column,
               label: column,
            });
         });

         this.setState({
            ...this.state.listWidgetSeries[this.props.selectedSerie],
            ...(this.state.listWidgetSeries[this.props.selectedSerie].columnProperties =
               columnsCopy),
         });
      }
   }

   getBPdata = (clickedRow) => {
      if (clickedRow.columnProperties && clickedRow.columnProperties.length === 0) {
         getList(clickedRow.listId, 1, 10).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            this.setState({
               listWidgetSeries: [
                  ...this.state.listWidgetSeries.map(
                     ({ id }) =>
                        id === clickedRow.id && {
                           ...clickedRow,
                           columnProperties: [
                              ...(clickedRow.columnProperties = responseData.columns),
                           ],
                        },
                  ),
               ],
            });
         });
      }
   };

   summary = () => {
      const { formatMessage } = this.props.intl;
      const clickedRow = this.getSerieById(this.state.selected);
      const dataSource = clickedRow.columnProperties;
      dataSource.forEach((record) => {
         if (record?.label === "api_recordActions") {
            record.label = this.props.intl.formatMessage({ id: "settings.recordActions" });
         }
      });

      const col = [
         {
            title: <IntlMessages id="settings.label" />,
            dataIndex: "label",
            key: "label",
            width: "100px",
         },
         {
            title: <IntlMessages id="settings.summaryColumn" />,
            dataIndex: "summary",
            width: "60px",
            render: (text, record) => {
               return dataSource.length >= 1 ? (
                  <Switch
                     onChange={(e) => handleChangeSettings(e, record, "addition")}
                     checked={record.addition}
                  />
               ) : null;
            },
         },
         {
            title: <IntlMessages id="settings.alignCol" />,
            dataIndex: "alignment",
            width: "180px",
            render: (text, record) =>
               data.length >= 1 ? (
                  <>
                     <RadioGroup
                        buttonStyle="solid"
                        size="small"
                        optionType="button"
                        onChange={(e) => handleChangeSettings(e.target.value, record, "alignment")}
                        defaultValue={record?.alignment ? record.alignment : "left"}
                        name={record?.label}
                     >
                        <Radio value="left">
                           <IntlMessages id="radio.left" />
                        </Radio>
                        <Radio value="center">
                           <IntlMessages id="radio.center" />
                        </Radio>
                        <Radio value="right">
                           <IntlMessages id="radio.right" />
                        </Radio>
                     </RadioGroup>
                  </>
               ) : null,
         },
         {
            title: <IntlMessages id="settings.imageSize" />,
            dataIndex: "imageSize",
            width: "100px",
            render: (text, record) => {
               return (
                  <Input
                     type="number"
                     style={{ minWidth: "50px" }}
                     placeholder="px"
                     min={0}
                     defaultValue={record?.imageWidth}
                     onChange={(e) =>
                        handleChangeSettings(Number(e.target.value), record, "imageWidth")
                     }
                  />
               );
            },
         },
         {
            title: <IntlMessages id="settings.imageDownloadAvailable" />,
            dataIndex: "imageDownloadAvailable",
            width: "150px",
            render: (text, record) => {
               return dataSource.length >= 1 ? (
                  <Switch
                     onChange={(e) => handleChangeSettings(e, record, "imageDownloadAvailable")}
                     checked={record?.imageDownloadAvailable}
                  />
               ) : null;
            },
         },
      ];

      const data = clickedRow.listWidgetSerieSettings.map((item) => ({
         ...item,
         translatedLabel: formatMessage({ id: `listSettings.${item.label}` }),
      }));

      const colSettings = [
         {
            title: <IntlMessages id="global.settings" />,
            dataIndex: "translatedLabel",
            key: "label",
            width: "50%",
         },
         {
            title: <IntlMessages id="settings.setSettings" />,
            dataIndex: "setSettings",
            width: "50%",
            render: (_, record) =>
               data.length >= 1 && (
                  <Switch
                     onChange={(e) => handleChangeSettings(e, record, "addition")}
                     defaultChecked={record.addition}
                  />
               ),
         },
      ];
      const handleChangeSettings = (value, record, settingName) => {
         this.setState(
            clickedRow.listWidgetSerieSettings.forEach((setting) =>
               setting.label === record.label ? (setting[settingName] = value) : null,
            ),
         );
         dataSource.forEach((item) => {
            if (item.label === record.label) {
               item[settingName] = value;
               item.serie = this.props.selectedSerie;
            }
         });
         this.props.updateWidgetSettings(this.state);
      };

      const handleRadio = (e, record, settingName) => {
         this.setState(
            clickedRow.columnProperties.forEach((setting) => {
               if (setting.label === record.label) {
                  setting[settingName] = e.target.value;
               }
            }),
         );
         dataSource.forEach((item) => {
            if (item.label === record.label) {
               item[settingName] = e.target.value;
               item.serie = this.props.selectedSerie;
            }
         });
         this.props.updateWidgetSettings(this.state);
      };

      return (
         <>
            {dataSource && dataSource.length ? (
               <>
                  <Table
                     className="gx-mb-3"
                     size="small"
                     dataSource={data}
                     columns={colSettings}
                     pagination={false}
                  />
                  <Table size="small" dataSource={dataSource} columns={col} pagination={false} />
               </>
            ) : (
               <>
                  <Spin
                     style={{
                        background: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                     }}
                  />
               </>
            )}
         </>
      );
   };

   render() {
      const { listWidgetSeries } = this.state;
      const components = {
         body: {
            row: EditableFormRow,
            cell: EditableCell,
         },
      };
      function handleUpdateSeries(basicSeries, listWidgetSeries) {
         if (listWidgetSeries) {
            listWidgetSeries.forEach((serie) => {
               const diff = basicSeries.filter((object1) => {
                  return !serie.listWidgetSerieSettings.some((object2) => {
                     return object2.label === object1.label;
                  });
               });
               serie.listWidgetSerieSettings = [...serie.listWidgetSerieSettings, ...diff];
            });
         }
         return listWidgetSeries;
      }
      const cols = this.columns.map((col) => {
         if (!col.editable) {
            return col;
         }
         return {
            ...col,
            onCell: (record) => ({
               record,
               editable: col.editable,
               dataIndex: col.dataIndex,
               title: col.title,
               handleSave: this.handleSave,
            }),
         };
      });
      return (
         <Form onSubmit={this.handleSubmit}>
            <div className="gx-pl-2">
               <div className="gx-pl-4">
                  <div>
                     <Table
                        components={components}
                        rowClassName={() => "list-settings-queries"}
                        bordered
                        className="gx-table-responsive"
                        dataSource={handleUpdateSeries(
                           ListScripts.getBasicSerieSettings(),
                           listWidgetSeries,
                        )}
                        expandedRowRender={this.summary}
                        onExpand={this.onExpandRow}
                        columns={cols}
                        pagination={false}
                        size="small"
                     />
                     <Button
                        onClick={this.handleAdd}
                        buttonType="primary"
                        style={{ marginBottom: 16, marginTop: 16 }}
                     >
                        <IntlMessages id="settings.AddSerie" />
                     </Button>
                  </div>
               </div>
               <Form.Item>
                  <Button className="gx-ml-5" buttonType="primary" htmlType="submit">
                     <IntlMessages id="global.preview" />
                  </Button>
               </Form.Item>
            </div>
         </Form>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      widgets: state.widgetSettings.settings,
   };
};

export default connect(mapStateToProps, {
   setWidgetInSheetParams,
   updateWidgetSettings,
})(injectIntl(ListSettings));
